import React, { useState, useEffect } from 'react';
import { reportsAPI, warehousesAPI } from '../../services/api';
import toast from 'react-hot-toast';

const fmt = (n) => Number(n||0).toLocaleString('en-IN',{minimumFractionDigits:2,maximumFractionDigits:2});
const fmtShort = (n) => Number(n||0).toLocaleString('en-IN',{style:'currency',currency:'INR',maximumFractionDigits:0});

export default function StockReport() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [warehouses, setWarehouses] = useState([]);
  const [warehouseId, setWarehouseId] = useState('');

  useEffect(() => { warehousesAPI.list().then(r => setWarehouses(r.data)).catch(() => {}); }, []);

  const load = async () => {
    setLoading(true);
    try {
      const r = await reportsAPI.stockValuation({ warehouse_id: warehouseId || undefined });
      setData(r.data);
    } catch { toast.error('Failed to load'); }
    finally { setLoading(false); }
  };

  return (
    <div>
      <div className="page-header"><div><h1>Stock Valuation</h1><p className="subtitle">Current stock value by batch</p></div></div>
      <div className="card mb-4"><div className="card-body">
        <div className="flex gap-3 items-center">
          <select className="form-select" style={{width:'auto',minWidth:200}} value={warehouseId} onChange={e => setWarehouseId(e.target.value)}>
            <option value="">All Warehouses</option>
            {warehouses.map(w => <option key={w.id} value={w.id}>{w.name}</option>)}
          </select>
          <button onClick={load} className="btn btn-primary" disabled={loading}>{loading ? 'Loading...' : 'Generate Report'}</button>
        </div>
      </div></div>

      {data && (
        <>
          <div className="stats-grid" style={{gridTemplateColumns:'repeat(3,1fr)'}}>
            <div className="stat-card"><div className="stat-info"><h3>Total Items</h3><div className="stat-value" style={{fontSize:24}}>{data.totals.totalItems.toLocaleString('en-IN')}</div></div></div>
            <div className="stat-card"><div className="stat-info"><h3>Value (at Cost)</h3><div className="stat-value" style={{fontSize:24}}>{fmtShort(data.totals.totalCostValue)}</div></div></div>
            <div className="stat-card"><div className="stat-info"><h3>Value (at MRP)</h3><div className="stat-value" style={{fontSize:24}}>{fmtShort(data.totals.totalMRPValue)}</div></div></div>
          </div>

          <div className="card">
            <div className="card-header"><h2>Stock Details</h2><span className="badge badge-blue">{data.items.length} batches</span></div>
            <div className="table-container">
              <table>
                <thead><tr><th>Product</th><th>SKU</th><th>Warehouse</th><th>Batch</th><th>Expiry</th><th style={{textAlign:'right'}}>Qty</th><th style={{textAlign:'right'}}>Cost/Unit</th><th style={{textAlign:'right'}}>MRP</th><th style={{textAlign:'right'}}>Value (Cost)</th><th style={{textAlign:'right'}}>Value (MRP)</th></tr></thead>
                <tbody>
                  {data.items.map((item,i) => {
                    const expiry = new Date(item.expiry_date);
                    const daysLeft = Math.ceil((expiry - new Date())/(1000*60*60*24));
                    return (
                      <tr key={i}>
                        <td><div style={{fontWeight:600}}>{item.name}</div>{item.generic_name && <div className="text-xs text-secondary">{item.generic_name}</div>}</td>
                        <td className="td-mono">{item.sku}</td>
                        <td className="text-secondary">{item.warehouse_name}</td>
                        <td className="td-mono">{item.batch_number}</td>
                        <td style={{color: daysLeft<=90 ? 'var(--danger)' : daysLeft<=180 ? 'var(--accent)' : 'inherit'}}>
                          {expiry.toLocaleDateString('en-IN',{month:'short',year:'2-digit'})}
                          {daysLeft <= 90 && <div className="text-xs">{daysLeft}d left</div>}
                        </td>
                        <td className="td-amount">{item.quantity}</td>
                        <td className="td-amount">₹{fmt(item.purchase_price)}</td>
                        <td className="td-amount">₹{fmt(item.mrp)}</td>
                        <td className="td-amount">₹{fmt(item.stock_value_cost)}</td>
                        <td className="td-amount font-bold">₹{fmt(item.stock_value_mrp)}</td>
                      </tr>
                    );
                  })}
                  {data.items.length===0 && <tr><td colSpan={10} className="text-center text-secondary" style={{padding:40}}>No stock data</td></tr>}
                </tbody>
                {data.items.length > 0 && (
                  <tfoot><tr style={{background:'#f8f9fa',fontWeight:700}}>
                    <td colSpan={5}>Total</td>
                    <td className="td-amount">{data.totals.totalItems.toLocaleString('en-IN')}</td>
                    <td colSpan={2}></td>
                    <td className="td-amount">₹{fmt(data.totals.totalCostValue)}</td>
                    <td className="td-amount">₹{fmt(data.totals.totalMRPValue)}</td>
                  </tr></tfoot>
                )}
              </table>
            </div>
          </div>
        </>
      )}

      {!data && !loading && (
        <div className="card"><div className="empty-state" style={{padding:60}}><div className="empty-icon">📦</div><h3>Click Generate to view stock valuation</h3></div></div>
      )}
    </div>
  );
}
